module.exports = require("./tzm.js");